import config from '_config';
import SessionService from '_services/common/sessionService';
import Echo from 'laravel-echo';

const token = SessionService.getLocalData('_token');

export { Pusher } from 'pusher-js';

export default new Echo({
  broadcaster: 'pusher',
  key: config.PUSHER_APP_KEY,
  cluster: config.PUSHER_APP_CLUSTER,
  encrypted: true,
  auth: {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  },
});
